import { ErrorBoundary } from 'components/common/error-boundary';
import { FlexTableWrapper } from 'components/common/layout/flex-table-wrapper';
import { AnalyticsHeader } from 'components/sections/analytics/header';
import { SessionHitsSummariesTable } from 'components/sections/analytics/session-hits-summaries/table';
import useAnalyticsStore from 'components/sections/analytics/store/use-analytics-store';
import { MachineContext } from 'contexts/machine.context';
import { SectionName } from 'enums/route.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext, useEffect, useState } from 'react';

const SUMMARIES_LIMIT = 300;

export const SessionHitsSummaries = () => {
  const { machine } = useContext(MachineContext);

  // after reassignment, fetch sessions again
  const [refetchKey, setRefetchKey] = useState(Date.now());

  // reload at mount (e.g. in case something was excluded for a specific session) and whenever switching machines
  useEffect(() => {
    if (!machine.machineID) {
      return;
    }

    useAnalyticsStore.getState().fetchSessions({
      machineID: machine.machineID,
      limit: SUMMARIES_LIMIT,
    });
  }, [machine.machineID, refetchKey]);

  return (
    <ErrorBoundary identifier="SessionHitsSummaries">
      <FlexTableWrapper
        gap={RADIX.FLEX.GAP.SECTION}
        header={<AnalyticsHeader />}
        table={
          <SessionHitsSummariesTable
            within={SectionName.Analytics}
            refetchSessions={async () => setRefetchKey(Date.now())}
            vFlex
          />
        }
      />
    </ErrorBoundary>
  );
};
